import { attachFallbacks } from "./projectImages";

// MOCK DATA — content & media scraped from www.hrdmimarlik.com
// Images use the original remote assets with local stock fallbacks (see FALLBACKS).

export const BRAND = {
  name: "HRD",
  full: "HRD Architecture",
  tagline: "Parametric 3D Wood Panels & Architectural Surfaces",
  meta: "[ 01 // MÄNTSÄLÄ & ISTANBUL PRODUCTION STUDIO ]",
  since: 2009,
  philosophy:
    "Ecological, sustainable design forms the foundation of our design philosophy.",
  quote: "Where the spirit does not work with the hand, there is no art.",
  quoteAuthor: "Leonardo da Vinci",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Products", to: "/products" },
  { label: "Services", to: "/services" },
  { label: "Portfolio", to: "/portfolio" },
  { label: "About us", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const CLIENTS = [
  "Massimo Dutti",
  "Zara",
  "Zara Home",
  "Bershka",
  "Oysho",
  "Pull&Bear",
  "Stradivarius",
  "Benetton",
];

export const FALLBACKS = [
  "https://images.unsplash.com/photo-1679996644490-14c2e6726d0f",
  "https://images.unsplash.com/photo-1566750838513-08a952c392c8",
  "https://images.unsplash.com/photo-1463995439889-6cc080aaf7dd",
  "https://images.unsplash.com/photo-1675528030748-d463ab87e8d5",
  "https://images.unsplash.com/photo-1543646269-fcc4ba67ac5f",
  "https://images.unsplash.com/photo-1701422052139-e72ee5e67249",
  "https://images.unsplash.com/photo-1697507695420-04623ccff2af",
  "https://images.unsplash.com/photo-1571205086863-9d186c5cb8fb",
  "https://images.unsplash.com/photo-1776278515712-9d5753884f5f",
  "https://images.unsplash.com/photo-1698047736474-3c1e5a0d3526",
  "https://images.unsplash.com/photo-1781032040825-04240013c228",
  "https://images.unsplash.com/photo-1685022515887-c2a10c137162",
];

const SRC = "https://www.hrdmimarlik.com/images/urun/";

export const PROJECTS = [
  { id: 366, slug: "toskana-vadisi-mb-house", title: "Toskana Vadisi — MB House", location: "Büyükçekmece, Istanbul", category: "Residential", year: "2023", client: "Private", scope: "Architecture / Interior / Bespoke Woodwork", image: SRC + "toskana-vadisi-villa_2.jpg" },
  { id: 259, slug: "acarkent-villa", title: "Acarkent Villa", location: "Beykoz, Istanbul", category: "Residential", year: "2022", client: "Private", scope: "Interior Architecture / Wall Panelling", image: SRC + "acarkent-villa_6.jpg" },
  { id: 387, slug: "inditex-group-store-applications", title: "Inditex Group Store Applications", location: "Türkiye", category: "Retail", year: "2015—2024", client: "Inditex Group", scope: "Rollout / Site Supervision / Fit-out", image: SRC + "zara-grup-magazalari_18.jpg" },
  { id: 330, slug: "le-meridien", title: "Le Méridien", location: "Adabükü, Bodrum", category: "Hospitality", year: "2021", client: "Marriott International", scope: "Interior / Acoustic Wood Surfaces", image: SRC + "le-meridien-bodrum_2.jpg" },
  { id: 391, slug: "le-meridien-peninsula-bar", title: "Le Méridien — Peninsula Bar", location: "Adabükü, Bodrum", category: "Hospitality", year: "2022", client: "Marriott International", scope: "Concept / Parametric Ceiling", image: SRC + "le-meridien-bodrum-peninsula-bar.jpg" },
  { id: 401, slug: "le-meridien-vitalica-wellness", title: "Le Méridien — Vitalica Wellness", location: "Adabükü, Bodrum", category: "Wellness", year: "2023", client: "Vitalica", scope: "Interior / Slat Wall Systems", image: SRC + "le-meridien-vitalica-wellness.jpg" },
  { id: 367, slug: "vitalica-wellness-macka-residences", title: "Vitalica Wellness — Maçka Residences", location: "Maçka, Istanbul", category: "Wellness", year: "2022", client: "Vitalica", scope: "Interior / CNC Wood Cladding", image: SRC + "vitalica-macka-residences_2.jpg" },
  { id: 309, slug: "estethica-medical-center-levent", title: "Estethica Medical Center", location: "Levent, Istanbul", category: "Healthcare", year: "2019", client: "Estethica", scope: "Interior Architecture", image: SRC + "estethica-tip-merkezi-levent.jpg" },
  { id: 368, slug: "dogu-bati-villas", title: "Doğu Batı Villas", location: "Göltürkbükü, Bodrum", category: "Residential", year: "2021", client: "Private", scope: "Architecture / Facade Cladding", image: SRC + "dogu-bati-villalari_2.jpg" },
  { id: 369, slug: "brandium-residence-penthouse", title: "Brandium Residence — Penthouse", location: "Ataşehir, Istanbul", category: "Residential", year: "2020", client: "Private", scope: "Interior / Bespoke Joinery", image: SRC + "brandium-penthouse_2.jpg" },
  { id: 370, slug: "owain-center", title: "Owain Center", location: "Avcılar, Istanbul", category: "Office", year: "2020", client: "Owain", scope: "Architecture / Interior", image: SRC + "owain-center-avcilar_4.jpg" },
  { id: 371, slug: "kofteci-mehmet-usta", title: "Köfteci Mehmet Usta", location: "Bayrampaşa, Istanbul", category: "F&B", year: "2019", client: "Mehmet Usta", scope: "Concept / Wood Surfaces", image: SRC + "kofteci-mehmet-usta_9.jpg" },
  { id: 372, slug: "united-colors-of-benetton", title: "United Colors Of Benetton", location: "Nişantaşı, Istanbul", category: "Retail", year: "2018", client: "Benetton", scope: "Store Fit-out Supervision", image: SRC + "benetton-magaza-uygl-kontrollugu_2.jpg" },
  { id: 374, slug: "new-tr-news-agency", title: "New TR News Agency", location: "İkitelli, Istanbul", category: "Office", year: "2019", client: "New TR", scope: "Interior / Acoustic Panels", image: SRC + "new-tr-haber-ajansi_3.jpg" },
  { id: 375, slug: "kmk-mechanical-head-office", title: "KMK Mechanical Head Office", location: "İkitelli, Istanbul", category: "Office", year: "2018", client: "KMK", scope: "Interior Architecture", image: SRC + "kmk-mekanik-merkez-ofis.jpg" },
  { id: 393, slug: "foz-gyo-business-office", title: "Foz GYO — Business Office", location: "Ümraniye, Istanbul", category: "Office", year: "2023", client: "Foz GYO", scope: "Interior / Parametric Reception Wall", image: SRC + "foz-gyo-business-office_9.jpg" },
  { id: 376, slug: "benetton-nidakule", title: "Benetton Nidakule", location: "Levent, Istanbul", category: "Office", year: "2019", client: "Benetton", scope: "Head Office Interior", image: SRC + "benetton-merkez-ofis-nidakule_4.jpg" },
  { id: 377, slug: "lamba-cafe", title: "Lamba Cafe", location: "Zeytinburnu, Istanbul", category: "F&B", year: "2018", client: "Lamba", scope: "Concept / Joinery", image: SRC + "lamba-cafe-zeytinburnu_2.jpg" },
  { id: 388, slug: "zekeriyakoy-villas", title: "Zekeriyaköy Villas", location: "Sarıyer, Istanbul", category: "Residential", year: "2022", client: "Private", scope: "Architecture / Wood Facade", image: SRC + "zekeriyakoy-villalari_4.jpg" },
  { id: 379, slug: "levent-residence", title: "Levent Residence", location: "Levent, Istanbul", category: "Residential", year: "2020", client: "Private", scope: "Interior Architecture", image: SRC + "levent-ofis-binasi_3.jpg" },
  { id: 380, slug: "spheros-valeo-head-office", title: "Spheros — Valeo Head Office", location: "Avcılar, Istanbul", category: "Office", year: "2019", client: "Valeo", scope: "Interior / Acoustic Ceiling", image: SRC + "spheros-valeo-merkez-ofis_3.jpg" },
  { id: 382, slug: "prodenta-dental-clinic", title: "Prodenta Dental Clinic", location: "Ataşehir, Istanbul", category: "Healthcare", year: "2018", client: "Prodenta", scope: "Interior / Wood Cladding", image: SRC + "prodenta-dis-klinigi_5.jpg" },
  { id: 383, slug: "asmed-hair-transplant-center", title: "Asmed Hair Transplant Center", location: "Ataşehir, Istanbul", category: "Healthcare", year: "2019", client: "Asmed", scope: "Interior Architecture", image: SRC + "asmed-sac-ekim-merkezi_7.jpg" },
  { id: 396, slug: "ulker-besler-office", title: "Ülker Besler Office", location: "Pendik, Istanbul", category: "Office", year: "2023", client: "Ülker", scope: "Interior / Slat Partitions", image: SRC + "ulker-besler-ofis-pendik.jpg" },
  { id: 390, slug: "kartal-residences", title: "Kartal Residences", location: "Kartal, Istanbul", category: "Residential", year: "2022", client: "Private", scope: "Interior / Joinery", image: SRC + "kartal-residences_5.jpg" },
  { id: 381, slug: "saygi-hospital-block-c", title: "Saygı Hospital — Block C", location: "Sultanbeyli, Istanbul", category: "Healthcare", year: "2020", client: "Saygı Hospital", scope: "Architecture / Interior", image: SRC + "saygi-hastanesi-c-blok_5.jpg" },
  { id: 384, slug: "plato-shopping-center", title: "Plato Shopping Center", location: "Sultanbeyli, Istanbul", category: "Retail", year: "2019", client: "Plato AVM", scope: "Architecture / Surfaces", image: SRC + "plato-alisveris-merkezi_3.jpg" },
  { id: 386, slug: "estethica-spa", title: "Estethica Spa", location: "Ataşehir, Istanbul", category: "Wellness", year: "2018", client: "Estethica", scope: "Interior / Parametric Wall", image: SRC + "estethica-spa-atasehir_5.jpg" },
  { id: 385, slug: "estethica-medical-center-atasehir", title: "Estethica Medical Center", location: "Ataşehir, Istanbul", category: "Healthcare", year: "2017", client: "Estethica", scope: "Interior Architecture", image: SRC + "estethica-tip-merkezi-atasehir_41.jpg" },
];

attachFallbacks(PROJECTS, FALLBACKS);

export const CATEGORIES = [
  "All",
  ...Array.from(new Set(PROJECTS.map((p) => p.category))),
];

export const SERVICES = [
  {
    no: "01",
    title: "Parametric 3D Wall Panels",
    text: "Algorithmically generated relief surfaces milled from solid birch, oak and ash. Each module is nested, numbered and delivered as a click-fit system.",
    points: ["Grasshopper / Rhino modelling", "5-axis CNC milling", "Seamless module tiling"],
  },
  {
    no: "02",
    title: "Acoustic Surface Systems",
    text: "Slat, perforated and micro-grooved acoustic panels with class A absorbers. Tested absorption values from αw 0.55 to 0.95.",
    points: ["Slat-on-felt systems", "Perforated MDF & veneer", "Acoustic reports"],
  },
  {
    no: "03",
    title: "CNC Wood Cladding",
    text: "Interior and ventilated exterior cladding in thermally modified timber, with concealed fixing rails and full shop drawings.",
    points: ["Thermo-ash & thermo-pine", "Concealed clip rails", "Fire-retardant options"],
  },
  {
    no: "04",
    title: "Architectural Woodwork & Joinery",
    text: "High-end bespoke joinery for hospitality, retail and residential interiors — from reception monoliths to full library walls.",
    points: ["Bespoke millwork", "Veneer matching", "On-site installation"],
  },
  {
    no: "05",
    title: "Interior Architecture & Design",
    text: "Since 2009 we deliver complete architectural and interior design services, from needs analysis to construction documentation.",
    points: ["Concept & space planning", "3D visualisation", "Technical detailing"],
  },
  {
    no: "06",
    title: "Project Management & Supervision",
    text: "Budget planning, tender packages with quantity take-offs and periodic site supervision until handover.",
    points: ["Tender packages", "Cost planning", "Site supervision"],
  },
];

export const PANELS = [
  {
    code: "WV-01",
    name: "Wave",
    family: "Parametric Relief",
    species: "Nordic Birch",
    depth: "28 mm",
    module: "600 × 2400 mm",
    finish: "Natural oil-wax",
    absorption: "αw 0.55",
    image: "https://images.unsplash.com/photo-1679996644490-14c2e6726d0f",
    text: "A continuous sine relief that reads as a soft textile when grazed by daylight. Modules tile in all four directions.",
  },
  {
    code: "DN-02",
    name: "Dune",
    family: "Parametric Relief",
    species: "Warm Oak",
    depth: "34 mm",
    module: "600 × 2400 mm",
    finish: "Matt lacquer",
    absorption: "αw 0.60",
    image: "https://images.unsplash.com/photo-1566750838513-08a952c392c8",
    text: "Asymmetric drifting ridges milled on a 5-axis bed. Designed for lobbies and long circulation walls.",
  },
  {
    code: "SL-03",
    name: "Slat",
    family: "Acoustic",
    species: "Ash / Birch",
    depth: "21 mm",
    module: "600 × 2700 mm",
    finish: "Clear UV oil",
    absorption: "αw 0.90",
    image: "https://images.unsplash.com/photo-1675528030748-d463ab87e8d5",
    text: "Classic slat-on-felt system with recycled PET backing. The quietest surface in the collection.",
  },
  {
    code: "FL-04",
    name: "Fluted",
    family: "Cladding",
    species: "Thermo Ash",
    depth: "25 mm",
    module: "300 × 2400 mm",
    finish: "Brushed & oiled",
    absorption: "αw 0.45",
    image: "https://images.unsplash.com/photo-1543646269-fcc4ba67ac5f",
    text: "Half-round flutes with a deep shadow gap. Available as a ventilated exterior rainscreen.",
  },
  {
    code: "TS-05",
    name: "Tessellate",
    family: "Parametric Relief",
    species: "Light Birch",
    depth: "40 mm",
    module: "600 × 600 mm",
    finish: "Raw sanded",
    absorption: "αw 0.65",
    image: "https://images.unsplash.com/photo-1697507695420-04623ccff2af",
    text: "A faceted triangulated field that shifts as you walk past it. Sold as single tiles for freeform compositions.",
  },
  {
    code: "PF-06",
    name: "Perfora",
    family: "Acoustic",
    species: "Oak Veneer",
    depth: "19 mm",
    module: "1200 × 2400 mm",
    finish: "Veneer, matt",
    absorption: "αw 0.95",
    image: "https://images.unsplash.com/photo-1701422052139-e72ee5e67249",
    text: "Micro-perforated veneer boards with hidden black fleece. Class A absorption for studios and auditoria.",
  },
];

export const SPECS = [
  ["Material", "FSC® certified birch, oak, ash, thermo-ash"],
  ["Panel depth", "19 – 40 mm relief on 12 – 18 mm carrier"],
  ["Max module", "1200 × 3000 mm"],
  ["Fixing", "Concealed clip rail / direct screw / adhesive"],
  ["Fire class", "B-s1,d0 on request (EN 13501-1)"],
  ["Acoustics", "αw 0.45 – 0.95 (EN ISO 354)"],
  ["Finish", "Oil-wax, matt lacquer, raw sanded, stained"],
  ["Lead time", "4 – 6 weeks ex works"],
];

export const PROCESS = [
  { no: "01", title: "Needs Analysis", text: "Knowing you well is the most important step of the project. We evaluate the analysis of the space and develop the spatial narrative accordingly." },
  { no: "02", title: "Design", text: "Once the layout is clear we move to the most enjoyable part. We share 3D visuals and physical samples of the environmentally sound materials we select." },
  { no: "03", title: "Project", text: "Budget and construction schedules are planned. Correct budgeting and optimum build time prevent both time and cash loss." },
  { no: "04", title: "Production", text: "Nesting, 5-axis milling, sanding and finishing in our own studio. Every module is numbered against the installation drawing." },
  { no: "05", title: "Application", text: "We install with all trades organised, or prepare a tender package with quantity lists. We can also take on site supervision only." },
];

export const TEAM = [
  {
    name: "Hüseyin Demirkundak",
    role: "Interior Architect / Founding Partner",
    bio: "Graduated in Interior Architecture from Pera Academy of Fine Arts, then continued at Palazzo Spinelli Academy, Florence. Took part in many projects at home and abroad. Working at HRD since 2009. Professional photography, model aircraft and sailing are his hobbies.",
    image: "https://www.hrdmimarlik.com/images/hakkimizda/huseyin-demirkundak.jpeg",
    portrait: "https://images.unsplash.com/photo-1598367815092-a2c0cbc1ea3d",
  },
  {
    name: "Reyhan Demirkundak",
    role: "Architect / Founding Partner",
    bio: "Graduated from the Faculty of Architecture at Trakya University, then continued her education at Palazzo Spinelli Academy, Florence. Took part in many, mainly domestic, projects. Continues design and application work at HRD since 2009. Her favourite thing is being a part-time traveller.",
    image: "https://www.hrdmimarlik.com/images/hakkimizda/reyhan-demirkundak_1.jpeg",
    portrait: "https://images.unsplash.com/photo-1744686909434-fd158fca1c35",
  },
];

export const ABOUT_TEXT = [
  "HRD has been providing architectural and interior design and application services since 2009. With our young and dynamic structure we follow the changing technologies of the world and produce projects that answer the needs of our clients.",
  "We know that qualified design emerges from the combination of many factors, and for this reason we evaluate every project according to its own data to produce functional, original designs. These factors cover communication with the client, needs analysis and functional use, material selection and original design, financial budget and application periods.",
  "Today our focus is primary manufacturing: we are makers of 3D parametric wood wall panels, custom CNC wood cladding and acoustic surface panels, produced between our Mäntsälä (Finland) and Istanbul (Türkiye) studios.",
];

export const STATS = [
  ["2009", "Founded"],
  ["420+", "Projects delivered"],
  ["2", "Production studios"],
  ["38k m²", "Panels milled"],
];

export const OFFICES = [
  {
    country: "Finland",
    name: "HRD Architecture / Keiki Concept Oy",
    address: ["Maisalantie 2 b", "04600 Mäntsälä, Finland"],
    phones: ["+358 41 3103702"],
    phoneNote: "WhatsApp",
    email: "info@hrdarchitecture.com",
    website: "https://www.hrdarchitecture.com",
    websiteLabel: "www.hrdarchitecture.com",
  },
  {
    country: "Türkiye",
    name: "HRD Mimarlık",
    address: [
      "Perpa Ticaret Merkezi B Blok",
      "Kat: 11 No: 1719",
      "Okmeydanı, İstanbul / Turkiye",
    ],
    phones: ["+90 212 220 76 16", "+90 212 220 76 86"],
    email: "info@hrdmimarlik.com",
    website: "https://www.hrdmimarlik.com",
    websiteLabel: "www.hrdmimarlik.com",
  },
];
